<script setup>
import { useForm } from '@inertiajs/inertia-vue3'

const props = defineProps({
	organisation: {
		type: Object,
		default: () => ([]),
	},
	user: {
		type: Object,
		default: () => ([]),
	},
	editable: {
		type: Boolean,
		default: false,
	},
})

const form = useForm({
	position: props.organisation.position,
})

function save() {
	form.post(route('dashboard.users.organisations.position', {
		user: props.user.id,
		organisation: props.organisation.id
	}))
}

</script>

<template>
	<div class="related-organisation grid md:grid-cols-2">
		<div>
			<p class="font-medium" data-testid="related-organisation-name">{{ organisation.name }}</p>
			<p class="text-sm">{{organisation.street_address}}</p>
			<p  class="text-sm">{{organisation.city}}, {{organisation.state}} {{organisation.postal_code}}</p>
			<Link :href="route('dashboard.organisations.show', organisation.id)" class="text-sm text-blue-500">View Organisation</Link>
		</div>
		<div v-if="editable">
			<Input
				:label="'This users position within the ' + organisation.name + ' organisation'"
				v-model="form.position"
				:errors="form.errors.num_free_tickets"
				@keyup.enter="save"
				:testid="'related-organisation-position'"
			/>
			<small v-if="form.isDirty">
				Press enter to save
			</small>
		</div>
		<div v-else>
			<Label>Position within {{ organisation.name }}</Label>
			<p class="font-medium" :data-testid="'related-organisation-position'">{{ organisation.position }}</p>
			<p
				v-if="!organisation.position"
				class="text-gray-500 italic text-sm">
				No position set
			</p>
		</div>
	</div>
</template>